import React from 'react'
import Layout, { Container } from '../components/layout'
import ComingSoon from '../components/comingSoon'

function Chat() {
    return (
        <Layout>
            <Container>
                <ComingSoon />
            </Container>
        </Layout>
    )
}

export default Chat